var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSitesIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.595,
    height: 37.83,
    viewBox: "0 0 40.595 37.83",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_170",
    "data-name": "Rechteck 170",
    width: 40.595,
    height: 37.83,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_286",
    "data-name": "Gruppe 286",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_285",
    "data-name": "Gruppe 285",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_427",
    "data-name": "Pfad 427",
    d: "M35.069,16.83H25.646c-.378.671-.761,1.342-1.142,2h9.023L38,35.83H29.8a9.01,9.01,0,0,0-9-9h-3a5.006,5.006,0,0,1-5-5v-3h3.293c-.38-.658-.764-1.329-1.141-2H5.527L0,37.83H40.6ZM2.6,35.83l4.474-17H10.8v3a7.008,7.008,0,0,0,7,7h3a7.009,7.009,0,0,1,7,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_428",
    "data-name": "Pfad 428",
    d: "M24.656,9.8A8,8,0,0,0,25.3,7a5,5,0,0,0-10,0,8,8,0,0,0,.641,2.8A79.37,79.37,0,0,0,20.3,17.821c.285-.476.591-.991,1.063-1.8a62.089,62.089,0,0,0,3.3-6.222M17.3,6.919A2.882,2.882,0,1,1,20.179,9.8,2.882,2.882,0,0,1,17.3,6.919",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_429",
    "data-name": "Pfad 429",
    d: "M26.5,10.566A10.084,10.084,0,0,0,27.3,7a7,7,0,0,0-14,0,10.084,10.084,0,0,0,.792,3.566C15.527,14.043,20.3,21.66,20.3,21.66s4.77-7.617,6.208-11.094M15.3,7a5,5,0,0,1,10,0,8.009,8.009,0,0,1-.641,2.8A79.18,79.18,0,0,1,20.3,17.82,79.364,79.364,0,0,1,15.938,9.8,8.009,8.009,0,0,1,15.3,7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_430",
    "data-name": "Pfad 430",
    d: "M20.179,6.036a.883.883,0,1,1-.882.882.883.883,0,0,1,.882-.882m0-2a2.882,2.882,0,1,0,2.882,2.882,2.882,2.882,0,0,0-2.882-2.882"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSitesIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Sites_icon.6ac604c7c74761d64d2b1f43895c7ba3.svg";